import ActiveRecord from './active_record/base'

class TeamDay extends ActiveRecord {
	static tableName = 'teamDays'
}

export default TeamDay
